import { HttpLoaderFactory } from '../shared/shared.module';
var ɵ0 = HttpLoaderFactory;
//import { GlobalErrorHandlerService } from '../global-error-handler.service';
var SearchModule = /** @class */ (function () {
    function SearchModule() {
    }
    return SearchModule;
}());
export { SearchModule };
export { ɵ0 };
